mutation TranscriptDelete($input: TranscriptDeleteInput!) {
    transcriptDelete(input: $input) {
        activity {
            id
            transcription
            transcriptionStatus
        }
    }
}
